module.exports = __webpack_public_path__ + "static/feature2-ceccdc1947d5389289c91f11a3c40e97.png";